import React, { Component } from 'react';

import { render } from 'react-dom';
import Select, {components} from 'react-select';
const { ValueContainer, Placeholder } = components;

const PlaceholderValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>

      <Placeholder {...props} isFocused={false}>
        {props.selectProps.placeholder}
      </Placeholder>
      <div style={{visibility: "hidden", height: "0", overflow: "hidden"}}>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
      </div>
      <div style={{visibility: "hidden"}}>{"t "}</div>
    </ValueContainer>
  );
};

export default PlaceholderValueContainer
